import { gql } from '@apollo/client';

const updateCurrentLessonAndLessonExerciseOfModuleUserMutation = gql`
  mutation updateCurrentLessonAndLessonExerciseOfModuleUserMutation(
    $_id: MongoID!
    $lessonId: MongoID
    $lessonExerciseId: MongoID
  ) {
    updateCurrentLessonAndLessonExerciseOfModuleUserMutation(
      _id: $_id
      lessonId: $lessonId
      lessonExerciseId: $lessonExerciseId
    ) {
      title
      message
    }
  }
`;
export default updateCurrentLessonAndLessonExerciseOfModuleUserMutation;
